{
  "AUTOMATION": {
    "HEADER": "自动化",
    "DESCRIPTION": "自动化可以取代和简化人工的现有程序，例如添加标签和将对话分配给最合适的代理人。 这使小组能够集中精力完成其实力，同时减少用于日常任务的时间。",
    "LEARN_MORE": "了解更多关于审计日志的信息",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "正在获取自动化规则",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "添加自动化规则",
      "SUBMIT": "创建",
      "CANCEL_BUTTON_TEXT": "取消",
      "FORM": {
        "NAME": {
          "LABEL": "规则名称",
          "PLACEHOLDER": "请输入规则名称",
          "ERROR": "名称是必填项"
        },
        "DESC": {
          "LABEL": "描述信息",
          "PLACEHOLDER": "输入规则说明",
          "ERROR": "描述是必需的"
        },
        "EVENT": {
          "LABEL": "事件",
          "PLACEHOLDER": "请选择一个",
          "ERROR": "事件是必填项"
        },
        "CONDITIONS": {
          "LABEL": "条件"
        },
        "ACTIONS": {
          "LABEL": "操作"
        }
      },
      "CONDITION_BUTTON_LABEL": "添加条件",
      "ACTION_BUTTON_LABEL": "添加操作",
      "API": {
        "SUCCESS_MESSAGE": "自动化规则添加成功",
        "ERROR_MESSAGE": "无法创建自动化规则，请稍后再试"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "姓名：",
        "ACTIVE": "状态",
        "CREATED_ON": "创建时间",
        "ACTIONS": "操作"
      },
      "404": "未找到自动化规则"
    },
    "DELETE": {
      "TITLE": "删除自动化规则",
      "SUBMIT": "删除",
      "CANCEL_BUTTON_TEXT": "取消",
      "CONFIRM": {
        "TITLE": "确认删除",
        "MESSAGE": "您确定要删除吗？ ",
        "YES": "是的，删除 ",
        "NO": "不，保留 "
      },
      "API": {
        "SUCCESS_MESSAGE": "自动化规则删除成功",
        "ERROR_MESSAGE": "无法删除自动化规则，请稍后再试"
      }
    },
    "EDIT": {
      "TITLE": "编辑自动化规则",
      "SUBMIT": "更新",
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "SUCCESS_MESSAGE": "自动化规则更新成功",
        "ERROR_MESSAGE": "无法更新自动化规则，请稍后再试"
      }
    },
    "CLONE": {
      "TOOLTIP": "克隆",
      "API": {
        "SUCCESS_MESSAGE": "自动化克隆成功",
        "ERROR_MESSAGE": "无法克隆自动化规则，请稍后再试"
      }
    },
    "FORM": {
      "EDIT": "编辑",
      "CREATE": "创建",
      "DELETE": "删除",
      "CANCEL": "取消",
      "RESET_MESSAGE": "更改事件类型将重置您在下方添加的条件和事件"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "保存时至少需要一个条件",
      "CONTACT_CUSTOM_ATTR_LABEL": "联系人自定义属性",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "对话自定义属性"
    },
    "ACTION": {
      "DELETE_MESSAGE": "保存时至少需要一个操作",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "在这里输入您的消息",
      "TEAM_DROPDOWN_PLACEHOLDER": "选择团队",
      "EMAIL_INPUT_PLACEHOLDER": "请输入电子邮件",
      "URL_INPUT_PLACEHOLDER": "请输入网址"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "激活自动化规则",
      "DEACTIVATION_TITLE": "停用自动化规则",
      "ACTIVATION_DESCRIPTION": "此操作将激活自动化规则 “{automationName}”。您确定要继续吗？",
      "DEACTIVATION_DESCRIPTION": "此操作将停用自动化规则 “{automationName}”。您确定要继续吗？",
      "ACTIVATION_SUCCESFUL": "自动化规则激活成功",
      "DEACTIVATION_SUCCESFUL": "自动化规则停用成功",
      "ACTIVATION_ERROR": "无法激活自动化，请稍后再试",
      "DEACTIVATION_ERROR": "无法停用自动化，请稍后再试",
      "CONFIRMATION_LABEL": "是",
      "CANCEL_LABEL": "否"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "无法上传附件。请重试",
      "LABEL_IDLE": "上传附件",
      "LABEL_UPLOADING": "上传中...",
      "LABEL_UPLOADED": "上传成功",
      "LABEL_UPLOAD_FAILED": "上传失败"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "属性键是必需的",
      "FILTER_OPERATOR_REQUIRED": "需要过滤器操作符",
      "VALUE_REQUIRED": "必须填写值",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "值必须介于 1 到 998 之间。",
      "ACTION_PARAMETERS_REQUIRED": "需要操作参数",
      "ATLEAST_ONE_CONDITION_REQUIRED": "至少需要一个条件",
      "ATLEAST_ONE_ACTION_REQUIRED": "至少需要一个动作"
    },
    "NONE_OPTION": "无",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "对话创建",
      "CONVERSATION_UPDATED": "对话已更新",
      "MESSAGE_CREATED": "消息已创建",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "对话已打开"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "分配客服",
      "ASSIGN_TEAM": "分配团队",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "移除已分配的团队",
      "ADD_LABEL": "添加标签",
      "REMOVE_LABEL": "移除标签",
      "SEND_EMAIL_TO_TEAM": "发送电子邮件给团队",
      "SEND_EMAIL_TRANSCRIPT": "通过邮件发送聊天记录",
      "MUTE_CONVERSATION": "开始会话",
      "SNOOZE_CONVERSATION": "暂停对话",
      "RESOLVE_CONVERSATION": "解决对话",
      "SEND_WEBHOOK_EVENT": "发送 Webhook 事件",
      "SEND_ATTACHMENT": "发送附件",
      "SEND_MESSAGE": "发送消息",
      "ADD_PRIVATE_NOTE": "添加私密注释",
      "CHANGE_PRIORITY": "更改优先级",
      "ADD_SLA": "添加SLA",
      "OPEN_CONVERSATION": "打开对话",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "啥都没有",
      "LOW": "低",
      "MEDIUM": "中",
      "HIGH": "高",
      "URGENT": "紧急的"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "消息类型",
      "PRIVATE_NOTE": "私人便笺",
      "MESSAGE_CONTAINS": "消息包含",
      "EMAIL": "Email",
      "INBOX": "收件箱",
      "CONVERSATION_LANGUAGE": "对话语言",
      "PHONE_NUMBER": "电话号码",
      "STATUS": "状态",
      "BROWSER_LANGUAGE": "浏览器语言",
      "MAIL_SUBJECT": "电子邮件主题",
      "COUNTRY_NAME": "国家",
      "COMPANY_NAME": "公司",
      "REFERER_LINK": "引荐链接",
      "ASSIGNEE_NAME": "负责人",
      "TEAM_NAME": "团队",
      "PRIORITY": "优先级",
      "LABELS": "标签"
    }
  }
}
